import { Environment } from "../../../environment";
import { Api, IPaginacao } from "../axios-config";

export interface IUnidade {
  idUnidade: number,
  nomeUnidade: string,
  cnpj: string,
}

interface IListagemUnidade {
  unidades: IUnidade[];
  paginacao: IPaginacao;
}


const getByCnpj = async (page = 1, cnpj: string, estado: boolean): Promise<IListagemUnidade | Error> => {
  try {
    const { data } = await Api.get(`Unidade/PesquisarUnidades/cnpj?PageNumber=${page}&PageSize=${Environment.LIMITE_DE_LINHAS}&cnpjPesquisado=${cnpj}&estado=${estado}`);

    if (data) {

      return {
        unidades: data.unidades,
        paginacao: data.paginacao
      };

    }

    return new Error('Erro ao listar os registros');
  } catch (error) {
    console.error(error);

    //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
    return new Error((error as { message: string }).message || 'Erro ao listar os registros');
  }
}

const list = async (cnpj: string): Promise<IUnidade[] | Error> => {
  try {
    const { data } = await Api.get(`Unidade/PesquisarUnidades/cnpj?cnpjPesquisado=${cnpj}&estado=true&listar=true`);

    if (data) {
      return data;
    }

    return new Error('Erro ao listar os registros');
  } catch (error) {
    console.error(error);

    //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
    return new Error((error as { message: string }).message || 'Erro ao listar os registros');
  }
}

const getById = async (idUnidade: string): Promise<IUnidade | Error> => {
  try {
    const { data } = await Api.get(`Unidade/PesquisarUnidades/id?id=${idUnidade}`);

    if (data) {
      return data;
    }

    return new Error('Erro ao listar os registros');
  } catch (error) {
    console.error(error);

    //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
    return new Error((error as { message: string }).message || 'Erro ao listar os registros');
  }
}

const create = async (dados: Omit<IUnidade, 'idUnidade'>): Promise<number | Error> => {
  try {
    const { data } = await Api.post('Unidade', dados);

    if (data) {
      return data;
    }

    return new Error('Erro ao criar o registro');
  } catch (error) {
    console.error(error);

    //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
    return new Error((error as { message: string }).message || 'Erro ao listar os registros');
  }
}

const update = async (dados: Omit<IUnidade, 'cnpj'>): Promise<void | Error> => {
  try {
    await Api.put('Unidade', dados);
  } catch (error) {
    console.error(error);

    //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
    return new Error((error as { message: string }).message || 'Erro ao atualizar o registro');
  }
};

const toggleEnabledById = async (idUnidade: number): Promise<void | Error> => {
  try {
    await Api.patch(`Unidade/desativar?id=${idUnidade}`);
  } catch (error) {
    console.error(error);

    return new Error((error as { message: string }).message || 'Erro ao habilitar/desabilitar o registro');
  }
};


export const UnidadeService = {
  getByCnpj,
  list,
  getById,
  create,
  update,
  toggleEnabledById,
}